import { functions } from '../stores/firebaseInit';

/**
 *
 * @param {('architecture-startOnboarding'|'projects-newProject'|'decisions-deprecate')} name
 */
export const callables = (name) => functions.httpsCallable(name);
